import React from 'react'

// redux
import { connect } from 'react-redux'


// includes
import NotificationItem from './includes/NotificationItem'
import SkeletonLoading from '../../Notifications__loadingSkeleton'
import SendersInfo from '../SendersInfo'
import Logo from '../Logo'
import CustomerMarketingEmails from '../CustomerMarketingEmails'

function CustomerOrderNotifications(props) {

    // props
    const {
        notificationsData,
        setNotificationsData,

        loading,
        loadingCount,

        notificationsList,

        handleNotificationClick,
        handleNotificationChange,
    } = props



    return (
        <React.Fragment>
            <div className="page-border-box2 mb-3 mb-md-4 customer-order-notifications">
                <div className="pbb2-inner d-flex">
                    {/* text-sec */}
                    <div className="text-sec media-body pe-3">
                        {/* header */}
                        <div className="app-header-wrapper heading-sm mb-2">
                            <p className="app-heading st-fw-600 text-capitalize mb-2">Customer order notifications</p>
                            <p className="app-desc st-fs-14">
                                These email notifications are sent to customers to confirm their orders and keep them informed about the order progress. You can customize any email to make it more personal, include necessary information, and promote your brand. You can upload and change the logo, edit the email subject, content, and layout.
                            </p>
                        </div>

                        <div className="customer-order-notifications-list">
                            {
                                loading ? (
                                    <React.Fragment>
                                        {
                                            loadingCount?.map(item => (
                                                <SkeletonLoading key={item} />
                                            ))
                                        }
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {
                                            notificationsList?.length ? notificationsList?.map(item => (
                                                <NotificationItem
                                                    key={item.template_id}
                                                    dataItem={item}

                                                    handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                                                    handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
                                                />
                                            )) : (
                                                <p>No notification(s) found</p>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            }
                        </div>

                    </div>
                </div>
            </div>

            {/* Customer Marketing Emails */}
            <CustomerMarketingEmails
                notificationsData={notificationsData}
                setNotificationsData={setNotificationsData}

                loading={loading}
                loadingCount={loadingCount}

                notificationsList={notificationsList}

                handleNotificationClick={(ev, tempId) => handleNotificationClick(ev, tempId)}
                handleNotificationChange={(ev, tempId) => handleNotificationChange(ev, tempId)}
            />

            {/* Senders Info */}
            <SendersInfo
                loading={loading}

                notificationsData={notificationsData}
                setNotificationsData={setNotificationsData}
            />

            {/* Logo */}
            <Logo
                loading={loading}

                notificationsData={notificationsData}
            />
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        commonToken: state.auth.commonToken
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(CustomerOrderNotifications)